<div class="header-plain">
  <h1>{{ 'files.file-manager' | translate }}</h1>
</div>
<div class="tab-container">
  <tabset>
    <tab [active]="activeTab === 'my-files'"
        (selectTab)="selectTab('my-files')"
        heading="{{ 'files.my-files' | translate }}"
        index="0">
      <ng-container *ngIf="activeTab === 'my-files'">
        <oes-files [title]="'data-room.dialogs.my-files' | translate"
                   [childDataRoom]="false"></oes-files>
      </ng-container>
    </tab>
    <ng-container *featureToggle="'shared-files'">
      <tab [active]="activeTab === 'shared-files'"
            (selectTab)="selectTab('shared-files')"
            heading="{{ 'files.shared-files' | translate }}"
            index="1">
        <ng-container *ngIf="activeTab === 'shared-files'">
          <div class="shared-files-filter">
            <label class="org-filter-label">{{ 'files.select-organization' | translate }}</label>
            <oes-custom-dropdown
              [options]="sharingOrgs"
              [mode]="'single'"
              [searchable]="true"
              [loading]="loadingOrgs"
              placeholderKey="files.select-organization-placeholder"
              (ngModelChange)="onOrgSelected($event)"
              [(ngModel)]="selectedOwnerOrgId">
            </oes-custom-dropdown>
            <button
              *ngIf="!selectedOwnerOrgId"
              type="button"
              class="btn btn-primary"
              (click)="openSharedExportModal()">
              {{ 'files.shared-export.open-button' | translate }}
            </button>
            <button
              *ngIf="!selectedOwnerOrgId"
              type="button"
              class="btn btn-secondary"
              (click)="toggleCurrentExportsPanel()">
              {{ (currentExportsPanelOpen ? 'files.current-exports.hide' : 'files.current-exports.show') | translate }}
            </button>
            <button
              *ngIf="selectedOwnerOrgId"
              type="button"
              class="btn btn-secondary"
              (click)="clearSelectedOrganization()">
              {{ 'files.shared-export.clear-organization' | translate }}
            </button>
          </div>

          <oes-current-exports-panel
            *ngIf="!selectedOwnerOrgId && currentExportsPanelOpen"
            [organizationId]="organizationId"
            (closed)="closeCurrentExportsPanel()">
          </oes-current-exports-panel>

          <ng-container *ngIf="selectedOwnerOrgId">
            <div *ngIf="loadingDocuments && selectedOwnerOrgName" class="loading-message">
              {{ 'files.loading-documents-from' | translate:{ orgName: selectedOwnerOrgName } }}
            </div>

            <oes-files [sharedFiles]="true"
                       [requireOwnerOrganizationSelection]="true"
                       [ownerOrganizationId]="selectedOwnerOrgId"
                       [title]="'data-room.dialogs.shared-title' | translate"
                       [childDataRoom]="false"
                       (documentsLoaded)="onDocumentsLoaded()"></oes-files>
          </ng-container>

          <oes-shared-export-modal
            [organizationId]="organizationId"
            (exportSubmitted)="onExportSubmitted()">
          </oes-shared-export-modal>
        </ng-container>
      </tab>
    </ng-container>
  </tabset>
</div>
